<template>
  <div class="px-4 sm:px-0">
    <figcaption v-if="entriesMap.length" class="mt-3 space-y-6">
      <div v-for="entry in entriesMap" :key="entry.id" class="space-y-4">
        <div v-if="entry.title" class="text-24 font-medium">{{ entry.title }}</div>
        <div class="relative space-y-4 text-md font-normal" v-html="entry.text.html"></div>
      </div>
    </figcaption>
    <div class="relative h-40 sm:h-[390px] w-full mt-3 sm:mt-0">
      <div class="hands">
        <li v-for="card in cardsMap" :key="card._id" :class="{ selected: selectedCard === card._id }" @click="setSelectedCard(card)"></li>
      </div>
    </div>
    <div class="text-24 font-medium my-3">Seçime Hazırlık Rehberi</div>
    <div v-for="instruction in instructions" :key="instruction.title" class="">
      <div class="relative flex flex-col pl-6 border-l border-l-[#424242] py-3 gap-3">
        <div class="absolute -left-3 top-1/3 w-6 h-6 rounded-full bg-[#6842EF]"></div>
        <div class="text-primary-300 text-20 font-medium">{{ instruction.title }}</div>
        <div class="text-md font-normal whitespace-pre-line">{{ instruction.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { shuffle } from 'lodash';
export default defineComponent({
  props: {
    date: {
      type: String,
      required: true,
    },
    cards: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const cardsMap = ref(shuffle(props.cards.filter((card) => card.periodicInfo.key)));
    const entriesMap = ref(props.cards.filter((card) => !card.periodicInfo.key));
    const instructions = [
      {
        title: "#1: Tarot'un Sırrını Keşfet",
        description:
          'Tarot destesi 78 karttan oluşur ve her bir kart, farklı sembollerle doludur. Bu kartlar, bilinçaltının derinliklerine inerek sana içsel bir yolculuk sunar. Her kart, yaşamının farklı bir yönünü temsil eder ve sana tam da ihtiyacın olan konuda rehberlik eder.​',
      },
      {
        title: '#2: Neden Tarot Falı Bakmalısın?',
        description:
          'Tarot, sadece geleceği görmek için değil, aynı zamanda kendi iç dünyanı anlamak için de bir araçtır. Günlük tarot falı, sana o günün enerjisini ve olası gelişmelerini göstererek daha bilinçli kararlar almanı sağlar.​ Yaşanacak tüm olasılıklar için heyecanlı mısın?',
      },
      {
        title: '#3: Kartını Seç ve Ruhunun Mesajını Dinle',
        description:
          'Her gün tarot falı sayfamızdan bir kart seçerek o günün enerjisini öğrenebilirsin. Kartını seçmeden önce sakince derin bir nefes al. Zihnini boşalt ve iç sesini dinleyerek kartını seç. Seçtiğin kart, sana özel bir mesaj taşıyacak ve önümüzdeki gün için içgörü elde edeceksin.',
      },
      {
        title: '#4: Kartının Anlamını Keşfet',
        description:
          'Geriye yapman gereken tek bir şey kaldı: Seçtiğin kartın anlamını öğrenmek. Her kart, aşk, kariyer, para, sağlık ve kişisel gelişim gibi konularda sana özel bilgiler sunar.',
      },
      {
        title: '#5: İçsel Yolculuğuna Devam Et',
        description:
          'Tarot, bir defalık bir deneyim değil, sürekli bir içsel yolculuktur. Her gün kart seçerek kendini daha iyi tanıyabilir ve yaşamının kontrolünü eline alabilirsin.​ Bugün hangi kararları almalı, nelerden kaçınmalısın? Merak ettiğin her sorunun cevabı Tarot’un sembollerinde saklı.',
      },
      {
        title: "#6: Tarot'un Büyüsünü Paylaş",
        description:
          'Tarot deneyimini arkadaşlarınla paylaşarak, onların da bu mistik yolculuğa katılmalarını sağlayabilirsin. Birlikte kart seçip yorumlamak, aranızdaki bağı güçlendirecektir.​\n\nUnutma: Tarot, sadece geleceği görmek için değil, aynı zamanda kendi iç dünyanı anlamak için de bir araçtır. Her kart, sana özel bir mesaj taşır ve seni daha bilinçli bir yaşama yönlendirir. Günlük tarot falını okumak için her gün bizi ziyaret etmeyi unutma!',
      },
    ];

    const selectedCard = ref(null);
    const setSelectedCard = (card) => {
      selectedCard.value = card._id;
      setTimeout(() => {
        document.location.href = `${card.route}`;
      }, 200);
    };
    return { entriesMap, instructions, selectedCard, setSelectedCard, cardsMap };
  },
});
</script>

<style lang="scss" scoped>
@keyframes hover {
  to {
    translate: 0px 12px;
  }
}

li {
  list-style: none;
}

.hands {
  --cards: 20;
  --curvature: 45deg;
  counter-reset: cards;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  @include sm {
    --curvature: 33deg;
    transform: translateY(315px);
  }
  transform: translateY(125px);
  transform-style: preserve-3d;

  > * {
    --curve: calc(var(--curvature) * ((var(--index) - (var(--cards) - 1) / 2) / var(--cards)));
    position: absolute;
    counter-increment: cards;
    flex: 0 0 auto;
    @include sm {
      width: 182px;
    }
    width: 75px;
    aspect-ratio: 182/300;
    transform-origin: 50% 100%;
    transform: rotate(var(--curve)) translateY(-225%);
    transition: all 0.3s;
    cursor: pointer;
    transform-style: preserve-3d;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: url('/images/tarot/tarot-selection-card.svg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      transition: all 0.3s, translate 0s;
      border-radius: 4px;
      pointer-events: none;
    }

    &.selected {
      animation: hover 1s ease-in-out infinite alternate forwards;
      &::before {
        transform: translateY(-42.5%) rotate(calc(var(--curve) * -1)) scale(1.2);
        transition-duration: 0.2s, 0s;
        translate: 0px 0px 1px;
      }
    }
  }

  @for $i from 1 through 32 {
    &:has(li:nth-child(#{$i})) {
      --cards: #{$i};
    }
    > *:nth-child(#{$i}) {
      --index: #{$i - 1};
    }
  }
}
</style>
